export default __webpack_public_path__ + "static/media/Earl Grey.605b6beb.jpg";